module.exports = __webpack_public_path__ + "static/media/history_31.0ea1ea35.jpg";